import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState, useEffect } from 'react';
import SelectBoxBar from "@/pcomponents/common/crud/write/select_box_bar";
import StudyListArea from "@/pages/comp/plan/study/study/common/list";
import SutdyShareListArea from "@/pages/comp/plan/study/share/common/list";
import { useSelector, useDispatch } from 'react-redux';

function StudyListUnionPage() {
  const [show_tab_arr, set_show_tab_arr] = useState([
    // { text: "교재", value: "study" },
    { text: "학습절차", value: "procedure" },
    // { text: "브릿지영어", value: "coolen" },
    { text: "공유", value: "share" },
  ]);
  const [show_tab, set_show_tab] = useState("procedure");
  let user = useSelector((state: any) => state.user);

  useEffect(() => {
    if (user.comp_sort_detail == "growple") {
      set_show_tab_arr([
        { text: "교재", value: "study" },
        { text: "학습절차", value: "procedure" },
        // { text: "브릿지영어", value: "coolen" },
        // { text: "공유", value: "share" },
      ]);
      set_show_tab("study");
    }
  }, [user]);

  let view_component: any = "";
  if (show_tab === "study") {
    view_component = <StudyListArea
      listOpt={{ s_use_sort: "study" }}></StudyListArea>;
  } else if (show_tab === "procedure") {
    view_component = <StudyListArea
      listOpt={{ s_use_sort: "procedure" }}></StudyListArea>;
  } else if (show_tab === "coolen") {
    view_component = <StudyListArea
      listOpt={{ s_use_sort: "coolen" }}></StudyListArea>;
  } else if (show_tab === "share") {
    view_component = <SutdyShareListArea></SutdyShareListArea>;
  }

  return (
    <CompLayout>
      <div>
        <SelectBoxBar
          valueTextArr={show_tab_arr}
          value={show_tab}
          name="show_tab"
          on_change={(inData: any) => {
            set_show_tab(inData.value);
          }}
          is_same_value_empty={false}
        ></SelectBoxBar>
      </div>
      <div className="mt-1">
        {view_component}
      </div>
    </CompLayout>
  );
}

export default StudyListUnionPage;